import React, { useState } from "react";
import { FormInputField } from "@arcteryx/components-form";
import { useTranslation } from "react-i18next";

const EmailInput = ({ id, label, required, errors, register, placeholder, validation = {}, name = "email" }) => {
  const { t } = useTranslation("components-form");
  const [isValidEmail, setValidEmail] = useState(false);

  return (
    <FormInputField
      id={id}
      type="email"
      name={name}
      label={label || t("Email address")}
      required={required}
      valid={isValidEmail}
      {...register(name, {
        required: t("Please enter your email address."),
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/i,
          message: t("Please enter a valid email address."),
        },
        validate: {
          validEmail: (value) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? setValidEmail(true) : setValidEmail(false),
          ...validation,
        },
      })}
      error={errors[name]}
      placeholder={placeholder}
    />
  );
};

export default EmailInput;
